module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/waiting-91a385570182f56057a8f978586873bb.svg";